// Види піц для фільтра й позначок на картках (новий дизайн).
// Гострі, вегетаріанські й ситні (хом'як, ключ meat) — прапорці товару з адмінки: is_spicy, is_vegetarian, is_double.
// Прапорця для морепродуктів немає, тож їх шукаємо в назві й описі.
const SEAFOOD = /креветк|мідії|мідій|тунець|тунц|кальмар|лосос/i;

export const PIZZA_KINDS = [
    // one — підпис бейджа на картці однієї піци
    { key: 'hot', label: 'Гострі', one: 'Гостра' },
    { key: 'meat', label: 'Ситні', one: 'Ситна' },
    { key: 'veg', label: 'Вегетаріанські', one: 'Вегетаріанська' },
    { key: 'sea', label: 'З морепродуктами', one: 'З морепродуктами' },
];

// Іконки видів (бейджі на фото й чипи фільтра) — у src/v2icons.js, там і підміняється набір
export { KIND_ICONS as PIZZA_ICONS } from '@/v2icons';
export { KIND_ICONS_ON as PIZZA_ICONS_ON } from '@/v2icons';

export function isHot(product) {
    return Number(product.is_spicy) === 1;
}

export function isVeg(product) {
    return Number(product.is_vegetarian) === 1;
}

export function isHearty(product) {
    return Number(product.is_double) === 1;
}

export function isSea(product) {
    return SEAFOOD.test((product.title || '') + ' ' + (product.description || ''));
}

export function pizzaIs(kind, product) {
    if (kind === 'hot') return isHot(product);
    if (kind === 'veg') return isVeg(product);
    if (kind === 'sea') return isSea(product);
    return isHearty(product);
}
